export default __webpack_public_path__ + "static/media/health.19bf0571.webp";